import { render, staticRenderFns } from "./FormInfoHeader.vue?vue&type=template&id=79d5b3fb&"
import script from "./FormInfoHeader.vue?vue&type=script&lang=js&"
export * from "./FormInfoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports